import { render, staticRenderFns } from "./CustomerManagementChange.vue?vue&type=template&id=15aff36d&scoped=true&"
import script from "./CustomerManagementChange.vue?vue&type=script&lang=js&"
export * from "./CustomerManagementChange.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManagementChange.vue?vue&type=style&index=0&id=15aff36d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aff36d",
  null
  
)

export default component.exports